import moment from "moment";
import { humanizer } from "humanize-duration";
import useGerarImagem from "@/Composables/useGerarImagem";
import useGerarArquivo from "@/Composables/useGerarArquivo";

export default function useUtils() {
    const humanizador = humanizer({
        language: "pt",
        round: true,
        conjunction: " e ",
        serialComma: false,
    });
    const segundosParaIntervaloRelogio = (tempo) => {
        if (tempo <= 0) {
            return "Atualizando...";
        }
        if (tempo > 24 * 60 * 60) {
            return humanizador(tempo * 1000, { units: ["d", "h"] });
        }
        if (tempo > 60 * 60) {
            return humanizador(tempo * 1000, { units: ["h", "m"] });
        }
        if (tempo > 60) {
            return humanizador(tempo * 1000, { units: ["h", "m", "s"] });
        }
        return humanizador(tempo * 1000, { units: ["h", "m", "s"] });
    };

    const gerarArquivo = useGerarArquivo();

    const baixar = (url = null) => {
        const link_url = gerarArquivo(url);
        window.open(link_url, "_blank");
    };

    const gerarImagem = useGerarImagem();

    // tamanho: true=2400 (legado), false=300 (thumb), ou largura em px
    const getImagem = (imagem, tamanho, status) => {
        if (!imagem?.id) {
            return "";
        }

        const minWidth = 300;
        let largura;
        if (typeof tamanho === "number") {
            largura = tamanho;
        } else if (tamanho) {
            largura = minWidth * 8;
        } else {
            largura = minWidth;
        }
        const altura = Math.round(largura * (11 / 16));

        const carimbos = {
            EM_LOTEAMENTO: "em_loteamento",
            SUSPENSO: "suspenso",
            CANCELADO: "cancelado",
        };
        const carimbo = carimbos[status] ?? null;

        return gerarImagem(
            imagem.id,
            largura,
            altura,
            "center",
            true,
            carimbo
        );
    };
    const formatDate = (date) => {
        return moment(date, "YYYY-MM-DD HH:mm:ss").format(
            "DD/MM/YYYY HH:mm:ss"
        );
    };

    const formatDateWithoutSeconds = (date) => {
        return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
    };

    const formatDateWithoutHours = (date) => {
        return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
    };

    const formatador = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    });

    const desformatador = (valor) => {
        valor = valor.replace(/[^0-9|^.,]/g, "");
        valor = valor.replace(/\./g, "");
        valor = valor.replace(/,/g, ".");

        return valor;
    };

    const formatadorLote = (num) => num.toString().padStart(3, "0");

    const timestampParaStringRelogio = (timestamp) =>
        new Date(timestamp * 1000 - new Date().getTimezoneOffset() * 60 * 1000)
            .toISOString()
            .substr(11, 8);

    const timestampsParaIntervaloRelogio = (base, futuro) => {
        return segundosParaIntervaloRelogio(futuro - base);
    };

    const imprimir = () => {
        window.print();
    };

    const limparEntradasNulas = (obj) => {
        return Object.fromEntries(
            Object.entries(obj)
                /* eslint-disable */
                .filter(([_, v]) => v != null)
                .map(([k, v]) => [
                    k,
                    v === Object(v) ? limparEntradasNulas(v) : v,
                ])
        );
    };
    const isObject = (item) => {
        return item && typeof item === "object" && !Array.isArray(item);
    };
    const mergeDeep = (target, ...sources) => {
        if (!sources.length) return target;
        const source = sources.shift();

        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return mergeDeep(target, ...sources);
    };

    const stripHTML = (html) => {
        let doc = new DOMParser().parseFromString(html || "", "text/html");
        return doc.body.textContent || "";
    };

    const nomeStatusLote = (statusLote) => {
        return statusLote?.nome;
    };

    const urlTransmisao = (leilao) => {
        if (leilao.link_transmissao) {
            switch (+leilao?.id_transmicao) {
                case 1:
                    return {
                        exibir_tansmissao_fora_auditorio: 0,
                        link_transmissao: `${leilao.link_transmissao}?rel=0&autoplay=1&loop=1`,
                    };
                case 2:
                    return {
                        exibir_tansmissao_fora_auditorio: 0,
                        link_transmissao: leilao.link_transmissao,
                    };
                default:
                    return null;
            }
        }
        return null;
    };

    return {
        baixar,
        getImagem,
        gerarImagem,
        formatDate,
        formatDateWithoutSeconds,
        formatDateWithoutHours,
        formatador,
        desformatador,
        formatadorLote,
        timestampParaStringRelogio,
        timestampsParaIntervaloRelogio,
        segundosParaIntervaloRelogio,
        imprimir,
        limparEntradasNulas,
        mergeDeep,
        stripHTML,
        nomeStatusLote,
        urlTransmisao,
    };
}
